import SecureLS from "secure-ls";

const ls = new SecureLS({
  encodingType: "aes",
  isCompression: false,
});

export const saveToken = (token) => {
  ls.set("jwtToken", token);
};

export const getToken = () => {
  return ls.get("jwtToken");
};

export const removeToken = () => {
  ls.remove("jwtToken");
};

export const saveUser = (user) => {
  ls.set("userInfo", user);
};

export const getUser = () => {
  return ls.get("userInfo");
};

export const removeUser = () => {
  ls.remove("userInfo");
};
